export enum AskedChangeField {
	FIRSTNAME = 'firstname',
	LASTNAME = 'lastname',
	PHONE = 'phone',
	GENDER = 'gender',
	BIRTH_DATE = 'birthDate',
	BIRTH_PLACE = 'birthPlace',
	ADDRESS = 'address',
	JOBS = 'jobs',
}

export enum AskedChangeFieldEnum {
	FIRSTNAME = 'firstname',
	LASTNAME = 'lastname',
	PHONE = 'phone',
	GENDER = 'gender',
	BIRTH_DATE = 'birthDate',
	BIRTH_PLACE = 'birthPlace',
	ADDRESS = 'address',
	JOBS = 'jobs',
}

export interface WorkerAskedChangeEntry {
	field: string;
	currentValue: unknown;
	proposedValue: unknown;
}

export interface WorkerAskedChangesResponse {
	workerId: string;
	askedChangesDate: string | null;
	changes: WorkerAskedChangeEntry[];
}

export enum AskedChangeAction {
	VALIDATE = 'validate',
	REJECT = 'reject',
}

export interface AskedChangeDecision {
	field: string;
	action: AskedChangeAction;
}

export interface SubmitAskedChangesBody {
	decisions: AskedChangeDecision[];
}

export interface AskedChangeDisplayItem {
	field: string;
	oldValue: string | null;
	newValue: string | null;
}
